// #297 — carry the backend's `refreshFailed` envelope flag on the list a find thunk resolves with.
// `response`/`entityList` can be RTK Query's Immer-frozen cache arrays, so NEVER mutate them:
// return a copy carrying the flag (a non-flagged result is returned as-is).
export function withRefreshFailed<T>(entityList: T[], response: unknown): T[] {
  const flagged = !!response && !Array.isArray(response)
    && (response as { refreshFailed?: boolean }).refreshFailed === true;
  if (!flagged) return entityList;
  return Object.assign([...entityList], { refreshFailed: true as const });
}
